// Static content for AAA Computers & Technologies Inc. point-of-presence site
// No backend / API. All content lives here.

export const COMPANY = {
  name: "AAA Computers & Technologies Inc.",
  shortName: "AAA Computers & Tech., Inc.",
  tagline: "Empowering businesses",
  taglineAccent: "with help of technology",
  heroDescription:
    "We configure workstations and servers according to your business' needs. Providing your business with networking infrastructure, data storage, and computational power.",
  email: "sales@aaacompu.com",
  phone: "510-623-7255",
  phoneHref: "+15106237255",
  fax: "510-623-7475",
  address: {
    line1: "41353 Albrae St",
    line2: "Fremont, CA 94538",
    full: "41353 Albrae St, Fremont, CA 94538",
  },
  year: new Date().getFullYear(),
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Location", href: "#location" },
  { label: "Support", href: "#contact" },
];

export const ABOUT_PRIMARY = {
  eyebrow: "About Us",
  title: "AAA Computers & Technologies Inc.",
  body:
    "We specialize in serving small to medium size businesses, providing you with the solutions that your business requires at all the stages and levels of computer infrastructure.",
  bullets: [
    "Data Management Solutions",
    "Visualization Hardware",
    "Networking Solutions",
  ],
};

export const ABOUT_SECONDARY = {
  eyebrow: "Integrated Solutions",
  title: "All you need at a single spot!",
  body:
    "Miracles can happen when multiple technologies come together and help you to come up with an integration solution for your needs.",
  features: [
    {
      title: "Integrated Solutions",
      desc: "All the things you need at a single place.",
    },
    {
      title: "RMA Support",
      desc: "No worries about your product warranties.",
    },
    {
      title: "Fast Turnaround Time",
      desc: "Quick responses to all your support queries.",
    },
  ],
  nodes: ["Servers", "Networking", "Workstations", "Visualization"],
};

// Products & Services — original four + new AI Hardware as a Service
export const SERVICES = [
  {
    id: "ecommerce",
    icon: "ShoppingBag",
    title: "e-Commerce",
    desc: "Reach us anytime, anywhere for your hardware needs.",
    color: "#22b07d",
  },
  {
    id: "mining",
    icon: "Pickaxe",
    title: "Mining Hardware",
    desc: "Get into serious crypto-currency mining.",
    color: "#4a6cf7",
  },
  {
    id: "distributed",
    icon: "Network",
    title: "Distributed Computing",
    desc: "Distributed computing compliant hardware and infrastructure.",
    color: "#ef6b6b",
  },
  {
    id: "endurance",
    icon: "ServerCog",
    title: "High Endurance",
    desc: "Server grade hardware, capable of running 24x7 with redundancy.",
    color: "#f5a623",
  },
  {
    id: "ai",
    icon: "BrainCircuit",
    title: "AI Hardware as a Service",
    desc: "On-demand GPU compute and AI-ready infrastructure — scale training and inference without the capital cost.",
    color: "#9b51e0",
  },
];

export const PROCESS = {
  eyebrow: "Process",
  title: "How it Works",
  steps: [
    {
      icon: "MessageSquare",
      title: "Consult",
      desc: "We understand your workloads and business goals.",
    },
    {
      icon: "Settings2",
      title: "Configure",
      desc: "We architect and configure the right hardware for you.",
    },
    {
      icon: "Rocket",
      title: "Deploy",
      desc: "We deliver and deploy your infrastructure on-site or hosted.",
    },
    {
      icon: "LifeBuoy",
      title: "Support",
      desc: "Ongoing RMA support and fast turnaround for peace of mind.",
    },
  ],
};

export const PARTNERS = [
  "Acer", "AMD", "Antec", "ASUS", "Broadcom", "Brocade", "Chenbro", "Dell",
  "Epson", "Honeywell", "HP", "HPE", "Intel", "Jira", "Juniper", "Kensington",
  "Kingston", "Mellanox", "Microsoft", "Motorola", "Nutanix", "NVIDIA", "PNY",
  "QLogic", "Red Hat", "Samsung", "SanDisk", "Seagate", "Supermicro",
  "Symantec", "Tyan", "Veeam", "WD",
];
